// src/pages/Teachers.js
import React, { useState } from 'react';
import { TwoToThree, FourToFive, Eight, HSAH, HSGov } from './assets/LessonContent';
import { Helmet } from 'react-helmet';


const Accordion = ({ items }) => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div id="teacherResourcesAccordion">
      {items.map((item, index) => (
        <div key={index} className="mb-4">
          <button
            className={`w-full bg-sky-600 hover:bg-sky-700 text-white font-bold py-2 px-4 rounded ${activeIndex === index ? 'bg-sky-600' : ''
              }`}
            onClick={() => toggleAccordion(index)}
          >
            {item.title}
          </button>
          <div
            className={`accordion-content bg-white shadow-md rounded px-8 pt-6 pb-8 mt-2 ${activeIndex === index ? 'block' : 'hidden'
              }`}
          >
            {item.content}
          </div>
        </div>
      ))}
    </div>
  );
};

const Teachers = () => {
  const accordionItems = [
    {
      title: 'Grades 2-3',
      content: (
        <TwoToThree />

      ),
    },
    {
      title: 'Grades 4-5',
      content: (
        <FourToFive />
      ),
    },
    {
      title: 'Grade 8',
      content: (
        <Eight />
      ),
    },
    {
      title: 'High School - American History',
      content: (
        <HSAH />
      ),
    },
    {
      title: 'High School - Government',
      content: (
        <HSGov />
      ),
    },
  ];

  return (
    <>
      <Helmet>
        <title>Teachers | Project V.O.T.E.</title>
      </Helmet>
      <div className="mx-auto max-w-7xl sm:px-4 md:px-6 lg:px-8 h-full">
        {/* Header Section */}
        <div className="relative rounded-t-lg bg-stone-100 py-8 sm:py-16 lg:py-24">
          <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex flex-col lg:flex-row lg:items-center">
              <div className="lg:flex-1">
                <h1 className="mt-1 text-4xl font-extrabold sm:text-5xl lg:text-6xl">
                  Teacher Resources
                </h1>
                <p className="max-w-xl mt-5 text-xl text-gray-900">
                  Welcome to the Teacher Resources page for Project V.O.T.E. (Voters of Tomorrow through Education).
                </p>
              </div>
              <div className="mt-8 lg:mt-0 lg:ml-8 lg:flex-shrink-0">
                <img
                  src={`${process.env.PUBLIC_URL}/images/texas-books.webp`}
                  alt="An illustration of Texas History notebooks"
                  className="w-[400px] h-[300px]"
                />
              </div>
            </div>
          </div>
        </div>

        {/* Content Section */}
        <div className="mx-auto max-w-7xl bg-white p-3">
          <p className="mb-6">This program is designed to provide you with the tools and materials needed to educate your students about the importance of voting and civic engagement. Aligned with the Texas Essential Knowledge and Skills (TEKS) standards, our resources are tailored to support students at different grade levels, ensuring that they become knowledgeable, responsible voters. Below, you'll find specific sections dedicated to grades 3-5, 6-8, and 9-12, each featuring materials and activities that meet the TEKS objectives for those levels.</p>
          <Accordion items={accordionItems} />
        </div>
      </div>
    </>
  );
};

export default Teachers;